module.exports = __webpack_public_path__ + "static/assets/62ec7be7fa9cfc190b8628803a82ed95.svg";